import { makeStyles } from 'tss-react/mui';

const useStylesActionButtonParent: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  actionButtonParent: {
    minWidth: 0,
    marginRight: '4px !important',
  },
  actionButtonParentOffset: {
    minWidth: 24,
  },
  actionButtonParentNoMargin: {
    marginRight: '0 !important',
  },
}));

export default useStylesActionButtonParent;
